module.exports = __webpack_public_path__ + "img/poke-bowl.8046ee36.jpg";